import { InputField } from '../../shared/models';

export interface RentalCarInformation {
    numberOf24HrPeriods: InputField<number | null>;
    formattedStartDate: InputField<string>;
    formattedEndDate: InputField<string>;
}